import './App.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Components/Navbar';
import PanelNavbar from './Components/PanelNavbar';
import Home from './Components/Home';
import Footer from './Components/Footer';
import Login from './Components/Login';
import Register from './Components/Register';
import Dashboard from './Components/Dashboard';
import Appointment from './Components/Appointment';
import Doctors from './Components/Doctors';
import About from './Components/About';
import Services from './Components/Services';
import MeetDoctors from './Components/MeetDoctors';
import Contact from './Components/Contact';

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    if (!token) {
        window.location.href = '/login';
        return null;
    }
    return children;
};

function App() {
    const token = localStorage.getItem('token');

    return (
        <Router>
            <Navbar />
            {token && <PanelNavbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/doctors-admin-panel" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/appointments" element={<ProtectedRoute><Appointment /></ProtectedRoute>} />
                <Route path="/doctors" element={<ProtectedRoute><Doctors /></ProtectedRoute>} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/meet-doctors" element={<MeetDoctors />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;